import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'muestraprecompras'
})
export class MuestraprecomprasPipe implements PipeTransform {
  
  transform(value: any, args: string): any {
    const resultPost = [];
    for ( const post of value) {
      if (post.concepto.indexOf ("License Purchase") != -1) {
        resultPost.push (post);
      }
      
    }
    return resultPost;
  }

}
